import { render } from "./IconArrowDropDown.vue?vue&type=template&id=20fe4e18"
import script from "./IconArrowDropDown.vue?vue&type=script&lang=js"
export * from "./IconArrowDropDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__